import { inject } from "inversify";
import {
    IAddressLookupService,
    IAddressLookupServiceId,
    ICookieService,
    ICookieServiceId,
    IEnquiryFormService,
    IEnquiryFormServiceId,
    ILoggingService,
    ILoggingServiceId,
    IMessagingService,
    IMessagingServiceId,
    ISessionService,
    ISessionServiceId,
    IAnalyticsService,
    IAnalyticsServiceId,
    IHashingService,
    IHashingServiceId,
    Startup,
} from "@se/designsystem-core";
import { IPlatformClientId, IPlatformClient, IApiClientId, IApiClient } from "@se/platform";
import { EmailEnquiryFormComponent } from "./components/emailEnquiryFormComponent";

class SiteStartup extends Startup {
    constructor(
        @inject(IMessagingServiceId) protected messagingService: IMessagingService,
        @inject(ISessionServiceId) protected sessionService: ISessionService,
        @inject(IEnquiryFormServiceId) protected enquiryFormService: IEnquiryFormService,
        @inject(IAddressLookupServiceId) protected addressLookupService: IAddressLookupService,
        @inject(IPlatformClientId) protected platformClient: IPlatformClient,
        @inject(ICookieServiceId) protected cookieService: ICookieService,
        @inject(ILoggingServiceId) protected loggingService: ILoggingService,
        @inject(IAnalyticsServiceId) protected analyticsTrackingService: IAnalyticsService,
        @inject(IHashingServiceId) protected hashingService: IHashingService,
        @inject(IApiClientId) protected apiClient: IApiClient
    ) {
        super(
            messagingService,
            sessionService,
            enquiryFormService,
            addressLookupService,
            platformClient,
            cookieService,
            loggingService,
            analyticsTrackingService,
            hashingService
        );
    }

    public start() {
        // call the base start method to boot up common components from DS core
        super.start();

        document.querySelectorAll(".js-emailEnquiryForm-component").forEach((element: HTMLFormElement) => {
            new EmailEnquiryFormComponent(element, this.appInsights, this.messagingService, this.sessionService, this.apiClient);
        });
    }
}

export { SiteStartup };
